exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#bg-contatos {\n  background-color: #181717cf;\n  width: 94.7vw;\n  height: 93vh;\n  top: 0.1em;\n  position: absolute;\n  z-index: 3;\n}\n.alert-message-out {\n  border-bottom: solid 1px #1c869a;\n  border-left: solid 1px #1c869a;\n  padding: 0 0 3px 3px;\n}\n.alert-message {\n  border: solid 1px #1c869a;\n  padding: 0 5px 0 5px;\n  font-size: 13px;\n}\n.alert-message-in {\n  border-bottom: solid 1px gray;\n  border-left: solid 1px gray;\n  padding: 0 0 3px 3px;\n}\n.alert-message-fine {\n  border: solid 1px gray;\n  padding: 0 5px 0 5px;\n  font-size: 13px;\n}\n.icon-size {\n  width: 18px;\n  height: 18px;\n}\n", ""]);

// exports
